import { useTranslation } from "react-i18next";

import OwnedDeckCardList from "../../common/component/deck-library/OwnedDeckCardList";
import { useDeckCardTalentExpandShare } from "../../common/component/deck-library/useDeckCardTalentExpandShare";
import { useAuth } from "@/shared/stores/useAuth";

/** Talent / business view of their own Single Cards. */
export default function SingleCardListTalent() {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const { onExpandShare, shareModal } = useDeckCardTalentExpandShare({
    cardKind: "single",
  });

  return (
    <>
      <OwnedDeckCardList
        deckCardType="Single_Card"
        viewMode="talent"
        purchaseFilter="all"
        titleLabel={t("single_card", {
          ns: "taascard",
          defaultValue: "Single Card",
        })}
        emptyTitle={t("no_cards_title", {
          ns: "taascard",
          defaultValue: "No cards",
        })}
        emptySubtitle={t("no_cards_subtitle", {
          ns: "taascard",
          defaultValue: "No cards subtitle",
        })}
        showTalentFilter={false}
        injectTalentCreationPage
        enabled={Boolean(userInfo?.id)}
        onExpandShare={onExpandShare}
        deckCardShareKind="single"
      />
      {shareModal}
    </>
  );
}
